module.exports = __webpack_public_path__ + "60a1b3fc9f9768b812e3138dd93d282a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/sports/basketball.png
// module id = 1087
// module chunks = 0